module.exports = {
	CATEGORY_EXPORT: 'CATEGORY_EXPORT',
	CATEGORY_RESEARCH: 'CATEGORY_RESEARCH',
	ACTION_EXPORT: 'ACTION_EXPORT',
	ACTION_RESEARCH: 'ACTION_RESEARCH',
	ACTION_ADVANCED_RESEARCH: 'ACTION_ADVANCED_RESEARCH'
}



// WEBPACK FOOTER //
// ./src/utils/ApplicationConstants.js